import { useState, useCallback } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import "../../styles/desktop.css";

import DesktopNav from "./DesktopNav";
import DesktopFind from "./DesktopFind";
import DesktopPost from "./DesktopPost";
import DesktopTrips from "./DesktopTrips";
import DesktopChat from "./DesktopChat";
import DesktopAlerts from "./DesktopAlerts";
import DesktopProfile from "./DesktopProfile";

const DesktopLayout = ({ currentUser, setUserProfile }) => {
  const [tab, setTab]                 = useState("find");
  const [unreadCount, setUnreadCount] = useState(0);
  const [chatCount, setChatCount]     = useState(0);
  const [tripsSubview, setTripsSubview] = useState(null);
  const [openChatReq, setOpenChatReq]   = useState(null);
  const [openLostChat, setOpenLostChat] = useState(null);
  const [chatActive, setChatActive]     = useState(false);

  const changeTab = useCallback(t => { setTab(t); }, []);

  const navigateTo = useCallback((toTab, subview) => {
    if (toTab === "chat" && subview?.chatId) {
      setOpenLostChat(subview);
      setTab("chat");
      return;
    }
    setTab(toTab);
    if (subview) setTripsSubview(subview);
  }, []);

  const screens = {
    find:    <DesktopFind currentUser={currentUser}/>,
    post:    <DesktopPost currentUser={currentUser}/>,
    trips:   <DesktopTrips currentUser={currentUser} forceView={tripsSubview} onViewApplied={() => setTripsSubview(null)} onNavigateChat={() => changeTab("chat")} onOpenChat={(req) => { setOpenChatReq(req); changeTab("chat"); }}/>,
    chat:    <DesktopChat currentUser={currentUser} openRequest={openChatReq} onOpenRequestHandled={() => setOpenChatReq(null)} onActiveChange={setChatActive} openLostChat={openLostChat} onLostChatHandled={() => setOpenLostChat(null)}/>,
    notifs:  <DesktopAlerts currentUser={currentUser} onCount={setUnreadCount} onChatCount={setChatCount} onNavigate={navigateTo}/>,
    profile: <DesktopProfile currentUser={currentUser} onLogout={() => signOut(auth)} onAvatarUpdate={url => setUserProfile(p => ({ ...p, avatar: url }))} onPhoneUpdate={phone => setUserProfile(p => ({ ...p, phone }))} onNavigate={navigateTo}/>,
  };

  return (
    <div className="desktop-app">
      <DesktopNav tab={tab} setTab={changeTab} unreadCount={unreadCount} chatCount={chatCount} user={currentUser}/>
      <div className="d-main" key={tab}>
        {screens[tab]}
      </div>
    </div>
  );
};

export default DesktopLayout;
